module.exports = __webpack_public_path__ + "static/media/variables.0318b03e.less";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/variables.less
// module id = 645
// module chunks = 0